export const LAYOUT_WIDTH = '1166px';
